module.exports = "/images/vendor/desiigner-svg/svg/places/ancient.svg?0f74193e604594cc3fab30ee2092cfde";